import React from 'react';

export const MARKET_TABS = [
  { id: 'overview', label: 'Overview', icon: '🧭' },
  { id: 'live', label: 'Live Market', icon: '⚡' },
  { id: 'performance', label: 'Performance', icon: '📊' },
  { id: 'crowd', label: 'Crowd Insights', icon: '👥' },
];

/** Internal-state-only tabs (no route change) — horizontally scrollable on mobile. */
export const MarketTabs = ({ active, onChange }) => (
  <div className="mk-tabs" role="tablist" aria-label="Market sections">
    {MARKET_TABS.map(tab => (
      <button
        key={tab.id}
        type="button"
        role="tab"
        aria-selected={active === tab.id}
        className={`mk-tab ${active === tab.id ? 'mk-tab--active' : ''}`}
        onClick={() => onChange(tab.id)}
      >
        <span className="mk-tab-icon" aria-hidden="true">{tab.icon}</span>
        <span className="mk-tab-label">{tab.label}</span>
      </button>
    ))}
  </div>
);

export default MarketTabs;
